<template>
  <div class="table-responsive">
    <div
      v-if="stats"
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="row" v-if="showSearch">
        <div class="col-sm-12 col-md-12">
          <TableSearch :left="'left:18px'" @handleSearch="handleSearch" />
        </div>
      </div>
      <div class="row" style="max-height: 22rem; overflow: auto">
        <div class="col-sm-12">
          <table id="zero_config" class="table">
            <thead class="data-table-bg">
              <tr>
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
                <th>{{ $t("view_map") }}</th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length > 0">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="text-align: left"
                :class="{
                  'data-table-bg': index % 2 !== 0,
                }"
              >
                <td>{{ data.date }}</td>
                <td v-if="type !== 'loctrack'">{{ data.column1 }}</td>
                <td v-if="type == 'mote' || type == 'gps-vt' || type == 'lora' || type == 'glog5'">
                  {{ data.column2 }}
                </td>
                <td>{{ data.column3 }}</td>
                <td v-if="type !== 'loctrack'">{{ data.column4 }}</td>
                <td v-if="type !== 'loctrack'">{{ data.column5 }}</td>
                <td v-if="type == 'mote' || type == 'gps-vt' || type == 'lora' || type == 'glog5'">
                  {{ data.column6 }}
                </td>
                <td v-if="type == 'mote' || type == 'gps-vt' || type == 'lora' || type == 'glog5'">
                  {{ data.column7 }}
                </td>
                <!-- <td
                  v-if="
                    (type === 'loctrack' ||
                      type == 'mote' ||
                      type == 'gps-vt') &&
                      data.isValidLocation
                  "
                >
                  {{ data.lat.toFixed(4) }}
                </td>
                <td
                  v-if="
                    (type === 'loctrack' ||
                      type == 'mote' ||
                      type == 'gps-vt') &&
                      data.isValidLocation
                  "
                >
                  {{ data.lng.toFixed(4) }}
                </td> -->
                <td>
                  <button
                    @click.prevent="viewonMap(data.lat, data.lng)"
                    class="btn btn-primary"
                    v-if="data.isValidLocation"
                  >
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-else align="center">
              <tr align="center">
                <td colspan="8">
                  {{ $t("no-temp-humid") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <PaginationNew
        :pageCount="pageCount"
        :data="paginatedData"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableMixin from "../../mixins/tableMixinWithBackend";
import TableSearch from "../TableSearch.vue";
import PaginationNew from "../PaginationNew.vue";

export default {
  name: "Table",
  mixins: [tableMixin],
  props: {
    stats: Array,
    type: String,
    paginationMeta: Object,
    isFilter: Boolean,
    showSearch: {
      type: Boolean,
      default: true,
    },
    hasTemp2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumns: [],
      dataTable: [],
    };
  },
  mounted() {
    this.initialiseTable();
  },
  // created() {
  //   let sortOrders = {};
  //   this.tableColumns.forEach(function(key) {
  //     sortOrders[key[1]] = 1;
  //   });
  //   this.sortOrders = sortOrders;
  // },
  watch: {
    stats: {
      handler: function () {
        // console.log("charts watch");
        this.dataTable = [];
        this.initialiseTable();
      },
      deep: true,
    },
    hasTemp2() {
      this.dataTable = [];
      this.initialiseTable();
    },
    isFilter(update) {
      if (update) {
        this.pageNumber = 1;
        this.$emit("pageChange", this.params);
      }
    },
  },
  methods: {
    viewonMap(lat, lng) {
      window.open(`https://google.com/maps/search/${lat},${lng}`, "_blank");
    },
    initialiseTable() {
      const tempColumnLabel = this.$t("temp", { name: "(°C)" });
      const formattedTempColumnLabel = this.hasTemp2
        ? `${tempColumnLabel} - P | A`
        : tempColumnLabel;

      this.tableColumns = [
        [this.$t("date"), "date"],
        [formattedTempColumnLabel, "column1"],
        [this.$t("humid", { name: "(%)" }), "column2"],
        [this.$t("batt", { name: "(%)" }), "column3"],
        [this.$t("min-temp", { name: "(°C)" }), "column4"],
        [this.$t("max-temp", { name: "(°C)" }), "column5"],
        [this.$t("min-humid", { name: "(%)" }), "column6"],
        [this.$t("max-humid", { name: "(%)" }), "column7"],
      ];
      if (
        this.type !== "mote" &&
        this.type !== "gps-vt" &&
        this.type !== "lora" &&
        this.type !== "glog5"
      ) {
        this.tableColumns.splice(2, 1);
        this.tableColumns.splice(5, 1);
        this.tableColumns.splice(5, 1);
      }

      if (this.stats) {
        for (let i = 0; i < this.stats.length; i++) {
          let date = this.stats[i]?.deviceTimeStamp;
          const localTime = moment.utc(date).local();
          date = localTime.format("MMM Do YYYY, hh:mm a");
          const temperature = this.formatTemperature(
            this.stats[i]?.temperature
          );
          const temperatureSecondary = this.hasTemp2
            ? this.formatTemperature(this.stats[i]?.temperature2)
            : null;
          this.dataTable.push({
            column1: this.hasTemp2
              ? `${temperature} | ${temperatureSecondary}`
              : temperature,
            column2: this.stats[i]?.humidity?.toFixed(2),
            column3: this.stats[i].battery,
            column4: this.stats[i].deviceSettings.minTemperature,
            column5: this.stats[i].deviceSettings.maxTemperature,
            column6: this.stats[i].deviceSettings.minHumidity,
            column7: this.stats[i].deviceSettings.maxHumidity,
            dateOrig: this.stats[i].createdAt,
            date: date,
            lat: this.stats[i].latitude,
            lng: this.stats[i].longitude,
            isValidLocation: this.stats[i].validLocation,
          });
        }
      }
    },
    formatTemperature(value) {
      const parsed =
        typeof value === "number" ? value : value !== null ? parseFloat(value) : NaN;
      if (Number.isFinite(parsed)) {
        return parsed.toFixed(2);
      }
      return "--";
    },
  },
  components: { TableSearch, PaginationNew },
};
</script>

<style scoped>
th,
td {
  /* min-width: 150px; */
  /* width: 100px; */
  white-space: nowrap;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>

<i18n>
{
	"en": {
		"batt": "Battery {name}",
		"date": "date",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"entries": "entries",
		"last-seen": "Last Seen",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"no-temp-humid": "No Temperature/Humidity data available for this period",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"search": "Search",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"temp": "Temperature {name}",
		"to": "to",
		"view": "View",
		"view_map": "View on Map"
	},
	"es": {
		"batt": "Batería {name}",
		"date": "fecha",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"no-temp-humid": "No hay datos de temperatura / humedad disponibles para este período",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"search": "Buscar",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"temp": "temperatura {name}",
		"to": "a",
		"view": "Ver",
		"view_map": "Ver en el mapa"
	},
	"fr": {
		"batt": "Batterie {name}",
		"date": "date",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"no-temp-humid": "Aucune donnée de température/humidité disponible pour cette période",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"search": "Chercher",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"temp": "Température {name}",
		"to": "à",
		"view": "Vue",
		"view_map": "Voir sur la carte"
	},
	"sw": {
		"batt": "Betri {name}",
		"date": "Tarehe",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"no-temp-humid": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa kipindi hiki",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"search": "Tafuta",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"temp": "Halijoto {name}",
		"to": "Kwa",
		"view": "Tazama",
		"view_map": "Tazama kwenye Ramani"
	}
}
</i18n>
